<template>
  <div class="text-center pt-6 pb-4">
    <StartButton />
  </div>
</template>
<script setup lang="ts">
import StartButton from '@/components/button/StartButton.vue'
</script>
